import React,{useState, useEffect, Suspense, useCallback} from 'react';
import { render, unstable_batchedUpdates } from 'react-dom';
// import trasee from '../../../data/trasee.json';
// import trasee_col from '../../../data/trasee_col.json';
// import trasee_anunturi from '../../../data/trasee_anunturi.json';
import { useLocation } from "react-router-dom";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function PopupExample(props) {
    return (
    <Popup trigger={<button class="trasee-cursa-obs-btn"> i</button>} position="right center">
      <div class="trasee-cursa-obs-message">{props.popupMessage}</div>
    </Popup>
    )
};

function Content(props) {
    const[trasee,setTrasee]=useState([]);
    const[traseeCol,setTraseeCol]=useState([]);
    const[traseeAnunturi,setTraseeAnunturi]=useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    if (trasee.length==0){
    Promise.all([
        fetch('data/trasee.json',{
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }}).then(function(response){
                    return response.json();
                }).then(function(myJson) {
                        return myJson;
                    }).catch((error) => {
                        setIsError(true);
                        console.log(error);
                      }),
        fetch('data/trasee_col.json',{
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }}).then(function(response){
                    return response.json();
                }).then(function(myJson) {
                        return myJson;
                    }).catch((error) => {
                        setIsError(true);
                        console.log(error);
                      }),
        fetch('data/trasee_anunturi.json',{
            headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }}).then(function(response){
                    return response.json();
                }).then(function(myJson) {
                    return myJson;
                    })
        ]).then((r1)=>{
            unstable_batchedUpdates(()=>{
                setTrasee(r1[0]);
                setTraseeCol(r1[1]);
                setTraseeAnunturi(r1[2]);
                setIsLoading(false);
            })
        }).catch((error) => {
            setIsLoading(false);
            setIsError(true);
            console.log(error);
        })
    }

    if (isLoading) {
        return <div>Loading...</div>;
    }
    else{
        return <Trasee trasee={trasee} trasee_col={traseeCol} trasee_anunturi={traseeAnunturi}/>;    
    }    

}

const Trasee = React.memo(function Trasee(props){
           
    const [plecare, setPlecare] = useState('')
    const [sosire, setSosire] = useState('')
    const location = useLocation();
    const [filteredTrasee, setFilteredTrasee] = useState([]);

    useEffect(() => {
        if (location.plecare){
            setPlecare(location.plecare);
        }
        if(location.sosire){
            setSosire(location.sosire);
        }
     }, [location]);
 
     
    const cursaOk=(c)=>{
        return (
            (
                plecare.length>=1 && 
                sosire.length>=1 && 
                c.statii.toLowerCase().indexOf(plecare.toLowerCase())>=0 &&
                c.statii.toLowerCase().indexOf(sosire.toLowerCase())>=0 && 
                (
                    c.statii.toLowerCase().indexOf(plecare.toLowerCase())
                    < c.statii.toLowerCase().indexOf(sosire.toLowerCase())
                )
            )
            ||
            (
                plecare.length>=1 && 
                sosire.length==0 && 
                (c.statii.toLowerCase().indexOf(plecare.toLowerCase())>=0)
            )
            ||
            (
                plecare.length==0 
                && sosire.length>=1 && 
                (c.statii.toLowerCase().indexOf(sosire.toLowerCase())>=0)
            )
            ||
            (
                plecare.length==0 && 
                sosire.length==0
            )
        )
    };

    useEffect(() => {
        const resultsTresee=props.trasee.filter(traseu => 
            (traseu.curse.filter(c => 
                cursaOk(c)==true
            ).length>0?true:false       
        ));
        setFilteredTrasee(resultsTresee);
    }, [plecare,sosire]);

    function inverseaza(){
        const bak_plecare=plecare;
        setPlecare(sosire)
        setSosire(bak_plecare)
    }

    return (
        <section className="pt-0 pb-90">
            <div className='row mb-5 p-5 trasee-cautare'>
                <div className="col-md-3 trasee-input-group">
                    <input  type="text"value={plecare} onChange={(e) => setPlecare(e.target.value)} placeholder="Localitate plecare" />
                </div>
                <button className='col-1 border-0 rounded m-0 p-0' onClick={inverseaza}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24"><path d="M480 256c-17.67 0-32 14.31-32 32c0 52.94-43.06 96-96 96H192L192 344c0-9.469-5.578-18.06-14.23-21.94C169.1 318.3 159 319.8 151.9 326.2l-80 72C66.89 402.7 64 409.2 64 416s2.891 13.28 7.938 17.84l80 72C156.4 509.9 162.2 512 168 512c3.312 0 6.615-.6875 9.756-2.062C186.4 506.1 192 497.5 192 488L192 448h160c88.22 0 160-71.78 160-160C512 270.3 497.7 256 480 256zM160 128h159.1L320 168c0 9.469 5.578 18.06 14.23 21.94C337.4 191.3 340.7 192 343.1 192c5.812 0 11.57-2.125 16.07-6.156l80-72C445.1 109.3 448 102.8 448 95.1s-2.891-13.28-7.938-17.84l-80-72c-7.047-6.312-17.19-7.875-25.83-4.094C325.6 5.938 319.1 14.53 319.1 24L320 64H160C71.78 64 0 135.8 0 224c0 17.69 14.33 32 32 32s32-14.31 32-32C64 171.1 107.1 128 160 128z"/>
                    </svg>
                </button>
                <div className="col-md-3 trasee-input-group ">
                    <input type="text" value={sosire} onChange={(e) => setSosire(e.target.value)} placeholder="Localitate destinatie" />
                </div>
            </div>
            <div className="container">
                <div className='accordion'>
                    {(filteredTrasee.length==0?
                        (
                            // (plecare.length!=0 || sosire.length!=0) &&
                            <div>Nu exista curse</div>
                        )
                        :
                        filteredTrasee.filter(traseu=>traseu.curse.length>0).map(traseu=> 
                        <>
                            <div className="accordion-item" style={{fontSize:"20px",fontWeight:"800"}}>
                                <h2 className="accordion-header" id={`header-traseu-${traseu.id_traseu}`}>
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#traseu-${traseu.id_traseu}`} aria-expanded="true" aria-controls={`traseu-${traseu.id_traseu}`}>
                                        {traseu.den_traseu}
                                    </button>
                                    <>
                                        {props.trasee_anunturi.filter(f=>(f.id_traseu==traseu.id_traseu)).map(a=>(
                                            <div className='p-3' style={{backgroundColor:"rgb(240, 131, 131)"}}>
                                                <h5 style={{fontWeight:"800"}}>{a.anunt_titlu}</h5>
                                                {/* <h6>{a.anunt_descriere}</h6> */}
                                                {a.anunt_descriere.map(linie=>(
                                                    <h6><pre className='m-0 p-0'>{linie}</pre></h6>
                                                ))}
                                            </div>
                                        ))}
                                    </>
                                </h2>
                                <div id={`traseu-${traseu.id_traseu}`} className="accordion-collapse collapse" aria-labelledby={`header-traseu-${traseu.id_traseu}`} data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        {(traseu.curse.filter(c=> cursaOk(c)==true).map(cursa => 
                                            <div>
                                                <div className='traseu-cursa-statii p-2'>
                                                    {(cursa.sens=="D"?"Dus":"Intors")} : {cursa.statii}
                                                </div>
                                                <div style={{overflow:"auto"}}>
                                                    <div className='row-fluid' >
                                                        <div className='col-lg-2 pe-3 col-fixed'>
                                                            <div style={{fontSize:"14px",fontWeight:"800"}}>Statii</div>
                                                            <div>-</div>
                                                        </div>
                                                        <>
                                                        <p style={{fontSize:"12px"}}  className='col-lg-1 pe-3'>
                                                            Cursa 1
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C1")).map(item =>{
                                                                return (
                                                                <>
                                                                <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                </>
                                                                )
                                                            })}
                                                           
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 2
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C2")).map(item =>{
                                                                 return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                               })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 3
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C3")).map(item =>{
                                                                 return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                               })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 4
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C4")).map(item =>{
                                                                 return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                            })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 5
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C5")).map(item =>{
                                                                 return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                           })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 6
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C6")).map(item =>{
                                                                 return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                           })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 7
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C7")).map(item =>{
                                                                return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                            })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 8
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C8")).map(item =>{
                                                                return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                            })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 9
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C9")).map(item =>{
                                                                 return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                            })}
                                                        </p>
                                                        <p style={{fontSize:"12px"}} className='col-lg-1 pe-3'>
                                                            Cursa 10
                                                            <br/>
                                                            {props.trasee_col.filter(c=>(c.Id_traseu==traseu.id_traseu && c.cursa=="C10")).map(item =>{
                                                                return (
                                                                    <>
                                                                    <p> {(cursa.sens=="D"?item.zile_dus:item.zile_intors)}</p>
                                                                    {item.obs_dus && cursa.sens=="D" && <PopupExample popupMessage={item.obs_dus} />}
                                                                    {item.obs_intors && cursa.sens=="I" && <PopupExample popupMessage={item.obs_intors} />}
                                                                    </>
                                                                    )
                                                            })}
                                                        </p>
                                                        </>
                                                    </div>
                                                    
                                                    {(cursa.orar.map(o => {
                                                        <div style={{fontSize:"20px",fontWeight:"800"}}>{o.sens}</div>  
                                                        const colStyle={color:((o.localitate.toLowerCase().includes(plecare.toLocaleLowerCase()) && plecare.length>0)?"Blue"
                                                            :(o.localitate.toLowerCase().includes(sosire.toLocaleLowerCase()) && sosire.length>0)
                                                        ?"Red":"Black"),fontSize:"14px"}
                                                        return(
                                                            <>
                                                            <div className='row-fluid gy-3 border-1 mb-2 mt-2'>
                                                                <div className='col-lg-2 pe-3  col-fixed' style={colStyle}>
                                                                    <div>{o.localitate}</div>
                                                                    <div style={{fontSize:"10px"}}>{o.statie}</div>
                                                                </div>
                                                                {/* {Array.apply(0, Array(10)).map(function (x, i) {
                                                                    return  <p className='col-lg-1 pe-3' style={colStyle}>{o.C1}</p>;
                                                                })} */}
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C1}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C2}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C3}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C4}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C5}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C6}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C7}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C8}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C9}</p>
                                                                <p className='col-lg-1 pe-3' style={colStyle}>{o.C10}</p>
                                                            </div>
                                                            </>
                                                        )
                                                    }))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </>
                        )
                    )}
                </div>
            </div>
        </section>
    );
});

export default Content;
